import moment from 'moment';

export const formatDate = (date: string) => {
    return moment(date).format('DD/MM/YYYY');
};
/** Libellé relatif à aujourd'hui : "Aujourd'hui", "Demain", "Dans 3 jours", "Il y a 2 jours" */
export const getRelativeDayLabel = (date: string): string => {
    const diff = moment(date).startOf('day').diff(moment().startOf('day'), 'days');
    if (diff === 0) return "Aujourd'hui";
    if (diff === 1) return 'Demain';
    if (diff === -1) return 'Hier';
    if (diff > 1) return `Dans ${diff} jours`;
    return `Il y a ${Math.abs(diff)} jours`;
};
